'use client';

import { Loader } from '@googlemaps/js-api-loader';
import { getEnvironmentVariables } from './getEnvironmentVariables';

type AutocompleteService = google.maps.places.AutocompleteService;
export type AutocompletePrediction = google.maps.places.AutocompletePrediction;

let autocompleteServiceSingleton: AutocompleteService | null = null;

const initializeAutocompleteService = async (
  apiKey?: string,
): Promise<AutocompleteService | null> => {
  const envVars = getEnvironmentVariables();
  if (!autocompleteServiceSingleton && typeof window !== 'undefined') {
    const loader = new Loader({
      apiKey: apiKey ?? envVars.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY ?? '',
      version: 'weekly',
      libraries: ['places'],
    });
    const importedService = await loader.importLibrary('places');
    autocompleteServiceSingleton = new importedService.AutocompleteService();
  }
  return autocompleteServiceSingleton;
};

export const getPlacePredictions = async (
  query: string,
  apiKey?: string,
): Promise<AutocompletePrediction[]> => {
  const service = await initializeAutocompleteService(apiKey);
  if (service) {
    const results = await service.getPlacePredictions({
      input: query,
      types: ['locality', 'postal_code', 'sublocality'],
      componentRestrictions: { country: 'US' },
    });
    return results.predictions;
  }
  return Promise.resolve([]);
};
